import React, { useMemo } from 'react';
import FlyOutMenu from '../../../../core/components/FlyOutMenu';
import FormEdit from '../../../../core/components/form/FormEdit';
import ValidInputDroplistText from '../../../../core/components/validation/ValidInputDroplistText';
import FormSubmit from '../../../../core/components/form/FormSubmit';
import Button from '../../../../core/components/Button';
import Dialog from '../../../../core/components/Dialog';

import { useIraListImport } from './useIraListImport';
import ValidInputFile from '../../../../core/components/validation/ValidInputFile';

const IraImportFlyOut = (): JSX.Element => {
    const { state, submit, cancel, setYear, setFile } = useIraListImport();

    if (!state.showing) {
        return <></>;
    }

    const disabled = state.importing || state.confirming;

    return (
        <>
            {state.confirming ? <ConfirmDialog /> : null}
            <FlyOutMenu
                title="Import IRA Payors"
                isOpen={true}
                onClose={cancel}
                width={530}
            >
                <div className="mfr-fly-out-menu">
                    <FormEdit
                        formName="ira-list-import"
                        cssName="mfr-restrictions-edit-form"
                    >
                        <ValidInputDroplistText
                            prop={state.ContractYear}
                            onChange={setYear}
                            disabled={disabled}
                        />
                        <ValidInputFile
                            prop={state.ImportFile}
                            onChange={setFile}
                            disabled={disabled}
                        />
                        <FormSubmit>
                            <Button
                                disabled={state.importing}
                                onClick={(): void => submit()}
                            >
                                {state.importing ? 'IMPORTING...' : 'IMPORT'}
                            </Button>
                            <span>
                                <Button
                                    cssName="btn-cancel"
                                    onClick={cancel}
                                    disabled={state.importing}
                                >
                                    CANCEL
                                </Button>
                            </span>
                        </FormSubmit>
                    </FormEdit>
                </div>
            </FlyOutMenu>
        </>
    );
};

const ConfirmDialog = (): JSX.Element => {
    const { state, submit, cancel } = useIraListImport();

    const title = 'Import ' + state.ContractYear.val + ' IRA Payors';
    const msg = 'Confirm you wish to import these payors?';

    const confirmOptions = useMemo(
        () => [
            {
                label: 'OK',
                onClick: (): void => submit(true),
            },
            {
                label: 'CANCEL',
                onClick: (): void => cancel(),
                cssName: 'btn-cancel',
            },
        ],
        [submit, cancel],
    );

    if (!state.confirming) {
        return <></>;
    }

    return (
        <Dialog
            open={true}
            setOpen={(): void => cancel()}
            title={title}
            message={msg}
            actions={confirmOptions}
        />
    );
};

export default IraImportFlyOut;
